export default __webpack_public_path__ + "static/media/no-midia.97e49af5.svg";